import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

export interface DataHealthSummaryDto {
  organizationId: number;
  organizationName: string;
  entityType: string;
  latestRecordCount: number;
  latestAnomalyCount: number;
  runAtUtc: string;
}

export interface DataHealthTrendPointDto {
  organizationId: number;
  entityType: string;
  runAtUtc: string;
  recordCount: number;
  anomalyCount: number;
}

export interface DataHealthDashboardDto {
  summary: DataHealthSummaryDto[];
  trends: DataHealthTrendPointDto[];
}

export interface DataHealthAnomalyDto {
  id: number;
  snapshotId: number;
  organizationId: number;
  organizationName: string;
  entityType: string;
  anomalyCode: string;
  summary: string;
  potentialCause?: string;
  recordReference?: string;
  severity: string;
  detectedAtUtc: string;
}

@Injectable({
  providedIn: 'root'
})
export class DataHealthService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = '/api/datahealth';

  getDashboard(entityType?: string, organizationId?: number): Observable<DataHealthDashboardDto> {
    let params = new HttpParams();

    if (entityType && entityType !== 'All') {
      params = params.set('entityType', entityType);
    }

    if (organizationId && organizationId > 0) {
      params = params.set('organizationId', organizationId);
    }

    return this.http.get<DataHealthDashboardDto>(`${this.apiUrl}/dashboard`, { params });
  }

  getAnomalies(entityType?: string, organizationId?: number): Observable<DataHealthAnomalyDto[]> {
    let params = new HttpParams();

    if (entityType && entityType !== 'All') {
      params = params.set('entityType', entityType);
    }

    if (organizationId && organizationId > 0) {
      params = params.set('organizationId', organizationId);
    }

    return this.http.get<DataHealthAnomalyDto[]>(`${this.apiUrl}/anomalies`, { params });
  }
}
